import { createContext } from "react";

export interface AtsIntegration {
  api_key: string;
  webhook_signature_token: string;
  report_url_type: string;
  default_package_id: string;
  customer_group_id: string;
  trigger_stage_id: string;
}

export interface TriggerStage {
  id: string;
  text: string;
}

export interface LeverIntegrationContextType {
  atsIntegrationData: AtsIntegration;
  triggerStages: Array<TriggerStage>;
  currentStep: number;
  setAtsIntegration: (atsIntegrationData: AtsIntegration) => void;
  setTriggerStages: (triggerStages: Array<TriggerStage>) => void;
  goToNextStep: () => void;
  goToPrevStep: () => void;
}

export const LeverIntegrationContext =
  createContext<LeverIntegrationContextType>({
    atsIntegrationData: {
      api_key: "",
      webhook_signature_token: "",
      report_url_type: "",
      default_package_id: "",
      customer_group_id: "",
      trigger_stage_id: "",
    },
    setAtsIntegration: (newState: AtsIntegration) => newState,
    triggerStages: [],
    setTriggerStages: (triggerStages: Array<TriggerStage>) => triggerStages,
    currentStep: 0,
    goToNextStep: () => {},
    goToPrevStep: () => {},
  });
